enum ParametricCostTypes {
  None,
  Duration,
  Emissions,
  Outcome,
}

export default ParametricCostTypes;
